<nx-headline-box
  class="mt-[1.25rem]"
  [label]="'orderModule.orderOperatedRentalLineItemsComponent.headline' | translate">
</nx-headline-box> 

<div class="mb-2">

  <!-- line items-->
  <div
    class="mb-2 flex flex-row"
    *ngFor="let item of lineItems; let i = index">
    <div class="bg-[#EAEEEF] px-5 border-b border-gray text-lg font-medium leading-4 flex flex-col pt-[1.188em] w-[62px]">
      {{i + 1}}
    </div>
    <div class="flex-grow">
      <!-- line item -->
      <nx-default-box class="bg-white border-b border-gray"
        [label]="item.text">
          {{item?.startDateTime | date:'dd.MM.yyyy HH:mm'}}&nbsp; - &nbsp; {{item?.endDateTime| date:'dd.MM.yyyy HH:mm'}}
      </nx-default-box>

      <!-- resource assignments -->
      <div
        *ngFor="let resourceAssignment of item?.resourceAssignments; let isFirst = first" 
        class="assignments"
        [ngClass]="{'mt-2': !isFirst}">
        <!-- resource assignment -->
        <nx-default-box
          [menuItems]="getAvailableMenuItems(resourceAssignment)"
          class="border-b border-l border-gray bg-[#EAEEEF]"
          icon="icon-item"
          [label]="resourceAssignment?.resource?.text">
        <ng-container chips>
          <ng-template nxTemplate="tag">
            <p-tag [value]="resourceAssignment?.getResourceAssignmentState() | translate" [severity]="resourceAssignment?.getResourceAssignmentStateSeverity()"></p-tag>
          </ng-template>
        </ng-container>
        <ng-container label>
          <a [routerLink]="['/resources/resource/', resourceAssignment?.resource?.id ]" class="jump ">
            {{resourceAssignment?.resource?.text}}
            <i [className]="'icon icon-jump-to'"></i>
          </a>
        </ng-container>
          {{resourceAssignment?.startDateTime | date:'dd.MM.yyyy HH:mm'}} - {{resourceAssignment?.endDateTime | date:'dd.MM.yyyy HH:mm'}}
        </nx-default-box>

        <!-- address -->
        <div class="flex flex-row">

          <!-- out handling -->
          <nx-default-box class="bg-white basis-full border-b border-gray"
            [label]="'orderModule.orderOperatedRentalLineItemsComponent.address' | translate">
            <ng-template nxTemplate="tag">
<app-address-indicator-v2 [size]="'small'" [grade]="resourceAssignment?.effectiveSchedulingInformation?.outAddress?.geocodingResultGrade"></app-address-indicator-v2>
            </ng-template>
            {{resourceAssignment?.effectiveSchedulingInformation?.outAddress?.getAddressString()}}
          </nx-default-box>

        </div>

        <!-- contacts -->
        <div class="flex flex-row">

          <!-- out handling -->
          <nx-default-box class="bg-white basis-full border-b border-gray"
            [label]="'orderModule.orderOperatedRentalLineItemsComponent.onSiteContacts' | translate">
            {{getName(resourceAssignment?.effectiveSchedulingInformation?.onSiteContacts)}}
          </nx-default-box>

        </div>

        <!-- tasks -->
        <div 
          class="border-b border-l border-gray bg-[#EAEEEF] px-4 py-2">
          {{'orderModule.orderOperatedRentalLineItemsComponent.tasks' | translate}}
        </div>
        <app-linked-tasks-list-view
          [orderId]="orderId"
          [linkedEntityId]="resourceAssignment?.resource?.id">
        </app-linked-tasks-list-view>

      </div>
    </div>
  </div>
</div>